// extracted by mini-css-extract-plugin
export default {"selectComponent":"select_selectComponent__DB58f","dropDown":"select_dropDown__0ki1p","widthFitParent":"select_widthFitParent__rr2Um","isMulti":"select_isMulti__buCWU"};